import React, { Component } from "react";
import { Route as BasicRoute, Redirect, Switch } from "react-router";
import { BrowserRouter, Route } from "react-router-dom";

import WrapperFrame from "@configuratorware/configurator-frontendgui/App/Frame";
import ErrorBoundary from "@configuratorware/configurator-frontendgui/App/Error/ErrorBoundary";

import combinedScreens from "@configuratorware/configurator-frontendgui/App/Screens";

import { getConf } from "@configuratorware/configurator-frontendgui/App/configuration.js";
// import Overview from "./Containers/Overview/Overview";

const NoMatch = () => <div>No routing found for the specified path.</div>;

const SomeComponent = () => <div>Some component</div>;

const Routing = (props) => {
  const basePath = getConf("routingBasePath", "/");

  return (
    <BrowserRouter basename={basePath}>
      <ErrorBoundary>
        <WrapperFrame>
          <Switch>
            <Route exact path="/" component={combinedScreens.Configurator} />

            <Redirect from="blank" to={basePath} />

            <Route
              path="/group::group"
              component={combinedScreens.Configurator}
            />

            <Route
              path="/identifier::identifier"
              component={combinedScreens.Configurator}
            />
            <Route
              path="/code::code"
              component={combinedScreens.Configurator}
            />

            <Route
              path="/widget/identifier::identifier"
              component={combinedScreens.CalculationWidget}
            />
            <Route
              path="/widget/code::code"
              component={combinedScreens.CalculationWidget}
            />

            <Route
              path="/designer-preview-widget"
              component={combinedScreens.DesignerProductPreview}
            />

            <Route component={NoMatch} />
          </Switch>
        </WrapperFrame>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routing;
